import { resolveUkEwBusiness } from './handlers/uk-ew-business.js';
import { resolveUkEwCalendar } from './handlers/uk-ew-calendar.js';
import { resolveUkEwClearCpr } from './handlers/uk-ew-clear-cpr.js';
import { resolveUsFederalBusiness } from './handlers/us-federal-business.js';
import { resolveUsFederalCalendar } from './handlers/us-federal-calendar.js';
import type { ResolveProceduralDateInput, ResolveProceduralDateResult } from './types.js';

export function resolveProceduralDate(
  input: ResolveProceduralDateInput,
): ResolveProceduralDateResult {
  switch (input.jurisdiction) {
    case 'uk-ew':
      return handleUkEw(input);
    case 'us-federal':
      return handleUsFederal(input);
  }
}

function handleUkEw(input: ResolveProceduralDateInput): ResolveProceduralDateResult {
  switch (input.dayCount) {
    case 'calendar':
      return resolveUkEwCalendar(input);
    case 'clear-cpr':
      return resolveUkEwClearCpr(input);
    case 'business':
      return resolveUkEwBusiness(input);
  }
}

function handleUsFederal(input: ResolveProceduralDateInput): ResolveProceduralDateResult {
  switch (input.dayCount) {
    case 'calendar':
      return resolveUsFederalCalendar(input);
    case 'business':
      return resolveUsFederalBusiness(input);
    case 'clear-cpr':
      throw new Error('clear-cpr day count is UK E&W only.');
  }
}
